/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 7c82d3198daa8e6c3409b1601901afdd */

import { ConcreteRequest } from "relay-runtime";

export type PartnerProgramEnrollmentStatus = "ACTIVE" | "CANCELLED" | "EXPIRED" | "NOT_STARTED" | "PENDING" | "WITHDRAWN" | "%future added value";
export type ModalBodyAutoRenewSubscriptionMutationVariables = {
    autoRenew: boolean;
    programEnrollmentId: string;
};
export type ModalBodyAutoRenewSubscriptionMutationResponse = {
    readonly setPartnerProgramEnrollmentAutoRenew: {
        readonly errors: ReadonlyArray<{
            readonly message: string | null;
            readonly field: ReadonlyArray<string | null> | null;
        }> | null;
        readonly partnerProgramEnrollment: {
            readonly id: string | null;
            readonly status: PartnerProgramEnrollmentStatus | null;
            readonly cancellationDate: string | null;
            readonly cancellationReason: string | null;
            readonly autoRenew: boolean | null;
            readonly subscriptionEndDate: string | null;
        } | null;
    } | null;
};
export type ModalBodyAutoRenewSubscriptionMutation = {
    readonly response: ModalBodyAutoRenewSubscriptionMutationResponse;
    readonly variables: ModalBodyAutoRenewSubscriptionMutationVariables;
};



/*
mutation ModalBodyAutoRenewSubscriptionMutation(
  $autoRenew: Boolean!
  $programEnrollmentId: ID!
) {
  setPartnerProgramEnrollmentAutoRenew(autoRenew: $autoRenew, programEnrollmentId: $programEnrollmentId) {
    errors {
      message
      field
    }
    partnerProgramEnrollment {
      __typename
      id
      status
      cancellationDate
      cancellationReason
      autoRenew
      subscriptionEndDate
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "autoRenew"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "programEnrollmentId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "autoRenew",
    "variableName": "autoRenew"
  },
  {
    "kind": "Variable",
    "name": "programEnrollmentId",
    "variableName": "programEnrollmentId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Error",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancellationDate",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cancellationReason",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "autoRenew",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subscriptionEndDate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ModalBodyAutoRenewSubscriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PartnerProgramEnrollmentPayload",
        "kind": "LinkedField",
        "name": "setPartnerProgramEnrollmentAutoRenew",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "partnerProgramEnrollment",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ModalBodyAutoRenewSubscriptionMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PartnerProgramEnrollmentPayload",
        "kind": "LinkedField",
        "name": "setPartnerProgramEnrollmentAutoRenew",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "partnerProgramEnrollment",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7c82d3198daa8e6c3409b1601901afdd",
    "metadata": {},
    "name": "ModalBodyAutoRenewSubscriptionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = 'd495b6a1eedfd189c67b0d5c5779f669';
export default node;
